<style lang="scss">
    .page-title {
        padding: 30px 40px 10px 40px;
        border-bottom:1px #d8d9df solid ;
        h2 {
            font-family: microsoft yahei;
            font-size:24px;
            color:#333333;
            font-weight: normal;

        }
    }
    .box{
        padding:40px 30px;
        p{
            font-family:PingFangSC-Regular;
            font-size:14px;
            color:#333333;
            line-height:24px;
        }
        .detail{
                line-height:30px;
                padding-bottom:10px;
                margin-bottom: 20px;
                a{text-decoration: underline;color:#5078e6;}
                .icon{
                    position: relative;
                    min-height:40px;
                    width:40px;
                    padding-left: 40px;
                    background: url("../../assets/images/msg.png")0 0 no-repeat;
                    background-size: 40px 40px;
                    .dot{
                        position:absolute;
                        right:0;
                        top:0;
                        background:#ff5555;
                        border:1px solid #ffffff;
                        width:11px;
                        height:11px;
                        border-radius:100%;
                    }
                }
                .title{float:left;
                    font-family: microsoft yahei;
                    font-size:18px;
                    color:#333333;}
                .time{float:right;
                    font-family:PingFangSC-Regular;
                    font-size:14px;
                    color:#c2c4ca;}
                .content{
                    font-family:PingFangSC-Regular;
                    font-size:14px;
                    color:#999999;
                }


        }
    }

</style>

<template>
    <div>
        <div class="page-title clearfix">
            <h2>消息中心</h2>
        </div>
        <div class="box" v-loading="loading">
            <div class="detail">
                <el-row>
                    <el-col :span="2">
                        <div class="icon"> </div>
                    </el-col>
                    <el-col :span="22">
                        <div class="clearfix">
                            <h3 class="title">{{detail.title}}</h3>
                            <div class="time">{{detail.date | formatDate}}</div>
                        </div>
                        <p class="content" v-html="detail.content">
                        </p>
                    </el-col>
                </el-row>
            </div>

        </div>


    </div>
</template>
<script>

	export default {

		data() {
		    return {
		    	loading:false,
                detail:{

				},
            }
        },
		computed:{

		},
        methods:{
            getDetail(){
            	this.loading = true
				this.$axios({
					method: 'get',
					url: '/messages/'+this.$route.params.id+'/detail'
				}).then( (res) =>{
					this.loading = false
					if(res.result){

						this.detail=res.data

					}else{
						this.$alert(res.message, '提示', {
							confirmButtonText: '确定',
						});
                    }
				}).catch( (err)=> {
					this.loading = false
					console.warn(err)
				})
            }
        },
        created(){
			this.getDetail()
        }
    }
</script>